import { Checkbox, DataSource, Layout, Panel, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutGeographicCityList extends Layout {
    checkboxNotActive: Checkbox;
    panelSpacer: Panel;
    searchpanelCity: SearchPanel;
    sourceGeographicCity: DataSource;
    tableCity: Table;
    textbox3DigitZip: Textbox;
    textboxAirportCode: Textbox;
    textboxCityName: Textbox;
    textboxCounty: Textbox;
    textboxId: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxOverrideZone: Textbox;
    textboxStateId: Textbox;
    textboxTimezone: Textbox;
    textboxZipCode: Textbox;
}
